// extracted by mini-css-extract-plugin
export default {"sectionFour":"SectionFour_sectionFour__uIvst","imageRow":"SectionFour_imageRow__aNLSQ","rowAnimation":"SectionFour_rowAnimation__0LQKF"};